import { useState, useEffect, useRef } from "react";

const FOTO = "/images/20250802_1630090.jpg";

// Imagens públicas sem restrição de CORS
const MONICA_IMG   = "/images/pngegg.png";
const CEBOLINHA_IMG= "/images/Cebolinha.png";
const MAGALI_IMG   = "/images/Magali.png";
const CASCAO_IMG   = "/images/Cascao.png";

// Fallback SVG simples caso a imagem não carregue
const FallbackChar = ({ cor, letra, tamanho = 80 }) => (
  <svg width={tamanho} height={tamanho} viewBox="0 0 80 80">
    <circle cx="40" cy="40" r="38" fill={cor} />
    <text x="40" y="48" textAnchor="middle" fontSize="32" fontWeight="bold" fill="white" fontFamily="sans-serif">{letra}</text>
  </svg>
);

const PERSONAGENS = [
  { nome:"Mônica",    src: MONICA_IMG,    cor:"#E63B75", letra:"M", tamanho:110, delay:"0s"   },
  { nome:"Cebolinha", src: CEBOLINHA_IMG, cor:"#4D96FF", letra:"C", tamanho:92,  delay:"0.2s" },
  { nome:"Cascão",    src: CASCAO_IMG,    cor:"#8B6914", letra:"C", tamanho:92,  delay:"0.4s" },
  { nome:"Magali",    src: MAGALI_IMG,    cor:"#FF8C00", letra:"M", tamanho:96,  delay:"0.6s" },
];

/* ── Personagens com fallback ── */
function Personagem({ p }) {
  const [erro, setErro] = useState(false);
  const [ok, setOk] = useState(false);
  return (
    <div style={{ animation:"bob 2s ease-in-out infinite", animationDelay:p.delay, display:"flex", flexDirection:"column", alignItems:"center" }}>
      {erro ? (
        <FallbackChar cor={p.cor} letra={p.letra} tamanho={p.tamanho} />
      ) : (
        <img
          src={p.src}
          alt={p.nome}
          width={p.tamanho}
          height={p.tamanho}
          crossOrigin="anonymous"
          style={{ objectFit:"contain", filter:"drop-shadow(0 4px 10px rgba(0,0,0,.3))", opacity: ok ? 1 : 0, transition:"opacity .4s" }}
          onLoad={() => setOk(true)}
          onError={() => setErro(true)}
        />
      )}
    </div>
  );
}

/* ── Confetti ── */
const Confetti = () => {
  const cores = ["#FF6B6B","#FFD93D","#6BCB77","#4D96FF","#FF9FF3","#FF8C42","#C8A2C8"];
  const pieces = Array.from({ length: 26 }, (_, i) => ({
    id: i, left: Math.random()*100, delay: Math.random()*4,
    dur: 3.5+Math.random()*2, cor: cores[Math.floor(Math.random()*cores.length)],
    size: 7+Math.random()*7, circle: Math.random()>.5,
  }));
  return (
    <div style={{ position:"fixed", inset:0, pointerEvents:"none", overflow:"hidden", zIndex:0 }}>
      {pieces.map(p=>(
        <div key={p.id} style={{
          position:"absolute", left:`${p.left}%`, top:"-20px",
          width:p.size, height:p.size, background:p.cor,
          borderRadius:p.circle?"50%":"3px",
          animation:`cffall ${p.dur}s ${p.delay}s infinite linear`,
        }}/>
      ))}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Fredoka+One&family=Nunito:wght@400;700;800&display=swap');
        @keyframes cffall{0%{transform:translateY(-20px) rotate(0deg);opacity:1}100%{transform:translateY(105vh) rotate(700deg);opacity:.2}}
        @keyframes bob{0%,100%{transform:translateY(0)}50%{transform:translateY(-12px)}}
        @keyframes pop{0%,100%{transform:scale(1)}50%{transform:scale(1.05)}}
        @keyframes wag{0%,100%{transform:rotate(-5deg)}50%{transform:rotate(5deg)}}
        @keyframes up{from{opacity:0;transform:translateY(26px)}to{opacity:1;transform:translateY(0)}}
        @keyframes zoomIn{from{opacity:0;transform:scale(.82)}to{opacity:1;transform:scale(1)}}
        @keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}

        /* ── BLOQUEIO TOTAL DE MODO ESCURO ── */
        :root {
          color-scheme: light !important;
          --supported-color-schemes: light !important;
        }
        
        html, body, #__next, #root {
          background-color: #FFF0F6 !important;
          background-image: linear-gradient(160deg,#FFF0F6 0%,#FFF8E1 45%,#EEF4FF 100%) !important;
          color: #333333 !important;
          /* Desativa o recurso "Force Dark" em navegadores baseados em Chromium (Android) */
          forced-color-adjust: none !important;
        }

        /* Garante que os cards e textos fiquem intactos */
        p, div, h1, h2, span, label {
          forced-color-adjust: none !important;
        }
      `}</style>
    </div>
  );
};

/* ── Countdown ── */
function Countdown({ target }) {
  const [t, setT] = useState({});
  useEffect(() => {
    const fn = () => {
      const d = target - Date.now();
      if (d <= 0) return setT({ done:true });
      setT({ days:Math.floor(d/86400000), hours:Math.floor(d/3600000)%24, min:Math.floor(d/60000)%60, sec:Math.floor(d/1000)%60 });
    };
    fn(); const id = setInterval(fn,1000); return ()=>clearInterval(id);
  }, [target]);

  if (t.done) return <p style={{fontFamily:"'Fredoka One',cursive",fontSize:22,color:"#FF4081",textAlign:"center"}}>🎉 Chegou o grande dia!</p>;
  return (
    <div style={{display:"flex",gap:10,justifyContent:"center",flexWrap:"wrap"}}>
      {[["Dias",t.days],["Horas",t.hours],["Min",t.min],["Seg",t.sec]].map(([l,v])=>(
        <div key={l} style={{background:"#ffffff",borderRadius:16,padding:"13px 15px",minWidth:64,textAlign:"center",boxShadow:"0 4px 0 #c2185b",border:"2px solid #FF6B9D"}}>
          <div style={{fontFamily:"'Fredoka One',cursive",fontSize:30,color:"#FF4081",lineHeight:1}}>{String(v??0).padStart(2,"0")}</div>
          <div style={{fontSize:11,color:"#999999",fontWeight:700,marginTop:4}}>{l}</div>
        </div>
      ))}
    </div>
  );
}

const Stars = () => (
  <div style={{display:"flex",justifyContent:"space-around",padding:"10px 0",opacity:.3,position:"absolute",top:0,left:0,right:0}}>
    {["⭐","🌸","⭐","🌸","⭐","🌸","⭐","🌸"].map((s,i)=><span key={i} style={{fontSize:17}}>{s}</span>)}
  </div>
);

export default function Convite() {
  const target = new Date("2026-07-04T16:00:00");
  const [name, setName] = useState("");
  const [qty, setQty] = useState(1);
  const [state, setState] = useState("idle");

  const playerRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    // Adiciona meta tags dinamicamente para forçar o Light Mode no navegador do celular
    let metaColorScheme = document.querySelector('meta[name="color-scheme"]');
    if (!metaColorScheme) {
      metaColorScheme = document.createElement('meta');
      metaColorScheme.name = 'color-scheme';
      document.head.appendChild(metaColorScheme);
    }
    metaColorScheme.content = 'light';

    // Configuração do YouTube
    if (!window.YT) {
      const tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      const firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    window.onYouTubeIframeAPIReady = () => {
      playerRef.current = new window.YT.Player("youtube-audio-player", {
        height: "0",
        width: "0",
        videoId: "fc6135Zl3gA",
        playerVars: {
          autoplay: 1,
          loop: 1,
          playlist: "fc6135Zl3gA",
          controls: 0,
          disablekb: 1,
          fs: 0,
          modestbranding: 1,
          rel: 0,
          showinfo: 0
        },
        events: {
          onReady: (event) => {
            event.target.setVolume(50);
            event.target.playVideo();
          },
          onStateChange: (event) => {
            if (event.data === window.YT.PlayerState.PLAYING) {
              setIsPlaying(true);
            } else {
              setIsPlaying(false);
            }
          }
        }
      });
    };

    const handleFirstInteraction = () => {
      if (playerRef.current && typeof playerRef.current.playVideo === "function") {
        playerRef.current.playVideo();
        playerRef.current.setVolume(50);
      }
      window.removeEventListener("click", handleFirstInteraction);
    };
    window.addEventListener("click", handleFirstInteraction);

    return () => {
      window.removeEventListener("click", handleFirstInteraction);
    };
  }, []);

  const togglePlay = () => {
    if (!playerRef.current) return;
    if (isPlaying) {
      playerRef.current.pauseVideo();
      setIsPlaying(false);
    } else {
      playerRef.current.playVideo();
      playerRef.current.setVolume(50);
      setIsPlaying(true);
    }
  };

  const confirm = () => {
    if (!name.trim()) return;
    setState("sending");
    setTimeout(() => setState("done"), 1400);
  };

  const card = {
    background:"#ffffff", borderRadius:20, padding:"24px 22px", marginBottom:18,
    boxShadow:"0 6px 0 rgba(230,59,117,.1)", border:"2px solid #FFE0EC",
    animation:"up .6s ease both",
  };
  const ttl = {
    fontFamily:"'Fredoka One',cursive", fontSize:21, color:"#E63B75",
    marginBottom:14, display:"flex", alignItems:"center", gap:8,
  };

  return (
    <div style={{minHeight:"100vh",background:"linear-gradient(160deg,#FFF0F6 0%,#FFF8E1 45%,#EEF4FF 100%)",fontFamily:"'Nunito',sans-serif",position:"relative",color:"#333333"}}>
      <Confetti />

      <div id="youtube-audio-player" style={{ display: "none" }}></div>

      <button 
        onClick={togglePlay}
        style={{
          position: "fixed", bottom: 20, right: 20, zIndex: 999,
          width: 50, height: 50, borderRadius: "50%",
          background: "linear-gradient(135deg,#FF4081,#FF6B9D)",
          color: "#ffffff", border: "2px solid white", cursor: "pointer",
          boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
          display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: 22, transition: "transform 0.2s"
        }}
        onMouseEnter={e => e.currentTarget.style.transform = "scale(1.1)"}
        onMouseLeave={e => e.currentTarget.style.transform = "scale(1)"}
        title={isPlaying ? "Pausar música" : "Tocar música"}
      >
        {isPlaying ? "🔊" : "🔇"}
      </button>

      {/* ══ HERO ══ */}
      <div style={{
        background:"linear-gradient(135deg,#FF4081 0%,#FF6B9D 55%,#FF8C42 100%)",
        padding:"0 20px 52px", textAlign:"center",
        borderRadius:"0 0 48px 48px", position:"relative", zIndex:1, overflow:"hidden",
      }}>
        <Stars />

        <div style={{display:"flex",justifyContent:"center",alignItems:"flex-end",gap:4,paddingTop:32,flexWrap:"wrap"}}>
          {PERSONAGENS.map(p => <Personagem key={p.nome} p={p} />)}
        </div>

        <div style={{display:"flex",justifyContent:"center",marginTop:16,marginBottom:18}}>
          <div style={{position:"relative",animation:"bob 3s ease-in-out infinite"}}>
            <div style={{position:"absolute",inset:-6,borderRadius:"50%",background:"linear-gradient(135deg,#FFE082,#FF6B9D,#FFE082)",animation:"spin 6s linear infinite",zIndex:0}}/>
            <div style={{position:"relative",zIndex:1,width:190,height:190,borderRadius:"50%",border:"5px solid white",overflow:"hidden",boxShadow:"0 10px 32px rgba(0,0,0,.28)"}}>
              <img src={FOTO} alt="Maria Cecília" style={{width:"120%",height:"120%",objectFit:"cover",objectPosition:"center top"}}/>
            </div>
            <div style={{position:"absolute",bottom:4,right:-8,zIndex:2,background:"#FFE082",borderRadius:"50%",width:52,height:52,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",boxShadow:"0 3px 8px rgba(0,0,0,.22)",border:"3px solid white"}}>
              <span style={{fontFamily:"'Fredoka One',cursive",fontSize:20,color:"#E63B75",lineHeight:1}}>2</span>
              <span style={{fontSize:9,color:"#E63B75",fontWeight:700}}>anos</span>
            </div>
          </div>
        </div>

        <div style={{display:"inline-block",background:"rgba(255,255,255,.2)",backdropFilter:"blur(6px)",borderRadius:30,padding:"6px 22px",marginBottom:12,border:"1px solid rgba(255,255,255,.4)"}}>
          <span style={{fontFamily:"'Fredoka One',cursive",color:"#ffffff",fontSize:14,letterSpacing:2}}>✨ CONVITE ESPECIAL ✨</span>
        </div>

        <h1 style={{fontFamily:"'Fredoka One',cursive",fontSize:"clamp(36px,8vw,58px)",color:"#ffffff",margin:"0 0 6px",textShadow:"0 3px 12px rgba(0,0,0,.22)",animation:"pop 2.5s ease-in-out infinite"}}>
          Maria Cecília
        </h1>
        <h2 style={{fontFamily:"'Fredoka One',cursive",fontSize:"clamp(18px,5vw,30px)",color:"#FFE082",margin:0,textShadow:"0 2px 8px rgba(0,0,0,.18)"}}>
          está completando 2 aninhos! 🎂
        </h2>
      </div>

      {/* ══ CONTEÚDO ══ */}
      <div style={{maxWidth:520,margin:"0 auto",padding:"20px 18px 60px",position:"relative",zIndex:1}}>

        <div style={{...card,animationDelay:".05s"}}>
          <p style={{fontSize:17,color:"#555555",lineHeight:1.9,margin:0,textAlign:"center"}}>
            🎉 Nossa princesinha está completando 2 aninhos! Vamos comemorar juntos? Vou ficar muito feliz com a presença de vocês nesse dia tão especial!
          </p>
        </div>

        <div style={{...card,animationDelay:".12s"}}>
          <div style={ttl}><span style={{fontSize:26}}>📅</span> Data & Hora</div>
          <div style={{background:"linear-gradient(135deg,#FFF0F6,#FFE0EC)",borderRadius:14,padding:20,textAlign:"center",border:"2px dashed #FF6B9D"}}>
            <div style={{fontFamily:"'Fredoka One',cursive",fontSize:26,color:"#E63B75"}}>Sábado, 4 de Julho de 2026</div>
            <div style={{fontFamily:"'Fredoka One',cursive",fontSize:22,color:"#FF8C42",marginTop:6}}>às 16h00 🕓</div>
          </div>
        </div>

        <div style={{...card,animationDelay:".2s"}}>
          <div style={ttl}><span style={{fontSize:26}}>⏰</span> Contagem Regressiva</div>
          <Countdown target={target} />
        </div>

        <div style={{...card,animationDelay:".28s"}}>
          <div style={ttl}><span style={{fontSize:26}}>📍</span> Local da Festa</div>
          <a
            href="https://maps.app.goo.gl/Y6ZmFKLBBZiCFqp97"
            target="_blank" rel="noopener noreferrer"
            style={{display:"flex",alignItems:"center",gap:14,background:"linear-gradient(135deg,#E8F5E9,#C8E6C9)",borderRadius:14,padding:"18px 20px",textDecoration:"none",border:"2px solid #66BB6A",transition:"transform .2s"}}
            onMouseEnter={e=>e.currentTarget.style.transform="scale(1.02)"}
            onMouseLeave={e=>e.currentTarget.style.transform="scale(1)"}
          >
            <span style={{fontSize:42}}>🗺️</span>
            <div>
              <div style={{fontFamily:"'Fredoka One',cursive",fontSize:19,color:"#2E7D32"}}>Ver no Google Maps</div>
              <div style={{fontSize:13,color:"#4CAF50",marginTop:3}}>Clique para ver a localização ↗</div>
            </div>
          </a>
        </div>

        <div style={{...card,animationDelay:".36s"}}>
          <div style={ttl}><span style={{fontSize:26}}>💌</span> Confirmar Presença</div>

          {state==="done" ? (
            <div style={{textAlign:"center",padding:"28px 20px",background:"linear-gradient(135deg,#FFF0F6,#FFE0EC)",borderRadius:14,animation:"zoomIn .5s ease"}}>
              <div style={{fontSize:62,animation:"bob 1.2s ease infinite"}}>🎉</div>
              <div style={{fontFamily:"'Fredoka One',cursive",fontSize:24,color:"#E63B75",marginTop:10}}>Presença confirmada!</div>
              <div style={{color:"#888888",marginTop:8,fontSize:15}}>Te esperamos no dia 04/07! 🎂</div>
              <div style={{marginTop:16,display:"flex",justifyContent:"center"}}>
                <img src={FOTO} alt="Maria Cecília" style={{width:72,height:72,borderRadius:"50%",objectFit:"cover",objectPosition:"center top",border:"3px solid #FF6B9D",animation:"wag 1.5s ease-in-out infinite"}}/>
              </div>
            </div>
          ) : state==="sending" ? (
            <div style={{textAlign:"center",padding:"28px 20px"}}>
              <div style={{fontSize:52,animation:"bob .8s ease infinite"}}>💕</div>
              <div style={{fontFamily:"'Fredoka One',cursive",fontSize:20,color:"#E63B75",marginTop:10}}>Confirmando...</div>
            </div>
          ) : (
            <div style={{display:"flex",flexDirection:"column",gap:14}}>
              <div>
                <label style={{fontSize:12,fontWeight:700,color:"#999999",display:"block",marginBottom:6,letterSpacing:1}}>SEU NOME</label>
                <input
                  type="text" placeholder="Como podemos te chamar? 😊"
                  value={name} onChange={e=>setName(e.target.value)}
                  style={{width:"100%",padding:"13px 16px",borderRadius:12,border:"2px solid #FFB3CC",fontSize:15,fontFamily:"'Nunito',sans-serif",outline:"none",boxSizing:"border-box",backgroundColor:"#ffffff",color:"#333333"}}
                  onFocus={e=>e.target.style.borderColor="#FF4081"}
                  onBlur={e=>e.target.style.borderColor="#FFB3CC"}
                />
              </div>
              <div>
                <label style={{fontSize:12,fontWeight:700,color:"#999999",display:"block",marginBottom:8,letterSpacing:1}}>QUANTAS PESSOAS VÊM?</label>
                <div style={{display:"flex",alignItems:"center",gap:14}}>
                  <button onClick={()=>setQty(q=>Math.max(1,q-1))} style={{width:42,height:42,borderRadius:"50%",border:"2px solid #FF6B9D",background:"white",color:"#FF6B9D",fontSize:24,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'Fredoka One',cursive"}}>−</button>
                  <span style={{fontFamily:"'Fredoka One',cursive",fontSize:28,color:"#E63B75",minWidth:32,textAlign:"center"}}>{qty}</span>
                  <button onClick={()=>setQty(q=>q+1)} style={{width:42,height:42,borderRadius:"50%",border:"2px solid #FF6B9D",background:"#FF6B9D",color:"white",fontSize:24,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'Fredoka One',cursive"}}>+</button>
                  <span style={{color:"#999999",fontSize:14}}>{qty===1?"pessoa":"pessoas"}</span>
                </div>
              </div>
              <button
                onClick={confirm}
                style={{background:"linear-gradient(135deg,#FF4081,#FF6B9D)",color:"white",border:"none",borderRadius:14,padding:"17px",fontSize:19,fontFamily:"'Fredoka One',cursive",cursor:"pointer",boxShadow:"0 5px 0 #c2185b",transition:"transform .1s,box-shadow .1s",marginTop:4}}
                onMouseDown={e=>{e.currentTarget.style.transform="translateY(4px)";e.currentTarget.style.boxShadow="0 1px 0 #c2185b"}}
                onMouseUp={e=>{e.currentTarget.style.transform="";e.currentTarget.style.boxShadow="0 5px 0 #c2185b"}}
              >
                ✅ Confirmar Presença
              </button>
            </div>
          )}
        </div>

        <div style={{textAlign:"center",marginTop:4}}>
          <img src={FOTO} alt="Maria Cecília" style={{width:64,height:64,borderRadius:"50%",objectFit:"cover",objectPosition:"center top",border:"3px solid #FFB3CC",animation:"bob 2.5s ease-in-out infinite",filter:"drop-shadow(0 4px 8px rgba(255,64,129,.25))"}}/>
          <p style={{color:"#aaaaaa",fontSize:12,marginTop:8}}>Feito com 💕 para a Maria Cecília</p>
        </div>

      </div>
    </div>
  );
}